/**
 * Search content — tab content for the user data panel.
 */

import { observer } from 'mobx-react-lite';
import { SearchInput } from './search-input';
import { SearchResultsList } from './search-results-list';

export const SearchContent = observer(function SearchContent() {
  return (
    <div className="search-content">
      <SearchInput />
      <SearchResultsList />
    </div>
  );
});
